export default __webpack_public_path__ + "static/media/thumbs-down.cda7195a.svg";